export const AppcuesConsts = {
  events: {
    login: 'Login',
    logout: 'Logout',
    draftSurveyCreated: 'Draft Survey Created',
    draftSurveyUpdated: 'Draft Survey Updated',
    lauchSurveyCreated: 'Survey Launched',
    surveyPaused: 'Survey paused',
    surveyClosed: 'Survey closed',
    acceptTos: 'Accepted Terms of Services',
    surveyLaunchedWithNoQuotas: 'Survey Launched With No Quotas',
    lastActive: 'Last Active',
  },
  eventDescriptions: {
    login: 'User Logged in',
    logout: 'User Logged out',
    draftSurveyCreated: 'User created a survey (id :id)',
    draftSurveyUpdated: 'User updated a survey (id :id)',
    lauchSurveyCreated: 'User launched a Survey (id :id)',
    surveyPaused: 'User paused a survey (id :id)',
    surveyClosed: 'User closed a survey (id :id)',
    acceptTos: 'User Accepted Terms of Services',
    surveyLaunchedWithNoQuotas: 'Survey Launched With No Quotas (id :id)',
    lastActive: 'User visited the dashboard',
  },
  fieldName: {
    hasAcceptedOptInCommunication: 'hasAcceptedOptInCommunication',
  },
  maxAttempts: 3,
  reConnectWaitTime: 3000,
};

export const environments = {
  DEVELOPMENT: 'development',
  QA: 'qa',
  STAGING: 'staging',
  PRODUCTION: 'production',
};
